<figure class="mat-figure"><ng-content></ng-content></figure>